import SelectorWrapper from "src/components/selectorwrapper/SelectorWrapper";
import OptionsProps from "src/components/streaming/findsomethingtostream/OptionsProps";
import { SFilterBlock, SLabelledCheck, SScrollContainer } from "src/components/streaming/findsomethingtostream/OptionsStyles";



//#region [Component]
export default function OptionsPeriod({ filterDispatch, filterState }: OptionsProps) {
	return <SelectorWrapper onClose={() => filterDispatch({ type: "hideOptions" })} heading="Periode">
		<SScrollContainer>
			<SFilterBlock>
				<SLabelledCheck selected={filterState.yearFrom === 0 && filterState.yearTo === 0}
					value="Alle"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 0, yearTo: 0 })}
				/>
				<SLabelledCheck selected={filterState.yearFrom === 1800}
					value="Før 1980"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 1800, yearTo: 1979 })}
				/>

				<SLabelledCheck selected={filterState.yearFrom === 1980}
					value="80-tallet"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 1980, yearTo: 1989 })}
				/>

				<SLabelledCheck selected={filterState.yearFrom === 1990}
					value="90-tallet"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 1990, yearTo: 1999 })}
				/>

				<SLabelledCheck selected={filterState.yearFrom === 2000}
					value="2000-tallet"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 2000, yearTo: 2009 })}
				/>

				<SLabelledCheck selected={filterState.yearFrom === 2010}
					value="2010-tallet"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 2010, yearTo: 2019 })}
				/>

				<SLabelledCheck selected={filterState.yearFrom === 2020}
					value="2020-tallet"
					selectionCallback={() => filterDispatch({ type: 'setPeriod', yearFrom: 2020, yearTo: 2029 })}
				/>
			</SFilterBlock>
		</SScrollContainer>
	</SelectorWrapper>;
}
//#endregion

//#region [Styles]

//#endregion